<section class="card">
    <div class="card-header">
      <span class="cat__core__title">
        <strong id="pageTitle">Register of Investor Complaints</strong>
      </span>
      <span style="float:right">
        <!-- <a routerLink="/investor"> -->
          <button (click)="add()" class="btn btn-success pull-right" [appHasPermission]="{'Url': '/register/Masterinvestorcomplaints/edit?goveva=true&email=', 'method':'put', 'menu': 'Masterinvestorcomplaints'}" class="btn btn-sm btn-primary mb-2" type="button">
            <i class="fa fa-plus"></i>&nbsp;Add</button>
        <!-- </a> -->
      </span>
      <span style="float:right">
        <button class="btn btn-success pull-right" class="btn btn-sm btn-primary mb-2" style="margin-right: 8px;" (click)="generateOutput()" type="button">
          <span>
            <i class="fa fa-save"></i>&nbsp;Generate Output </span>
        </button>
      </span>
    </div>
    <!-- Date Filter  -->
    <section class="card search-box">
      <div class="card-header" (click)="toggleSearchDiv()" style="cursor: pointer;">Modify Search <span class="pull-right"><i
            class="fa fa-filter" aria-hidden="true"></i></span> </div>
      <div class="card-block collapse" [ngClass]="{'collapse': !isSearchDivVisible}">
        <div class="row">
          <div class="col-lg-12">
            <div class="row">
  
              <div class="form-group col-md-3">
                <label>Name of the person lodging the complaint
                </label>
                <input type="text" class="form-control" [(ngModel)]="nameOfPersonLodgingComplaint">
                <br>
              </div>
  
              <!-- <div class="form-group col-lg-4 col-md-4 col-sm-4">
                <label>Date of receipt of complaint
                </label>
                <div class="input-group" (click)="$event.stopPropagation()">
                  <input class="form-control" [maxDate]="TodayDate" [(ngModel)]="dateOfReceiptOfComplaintModel"
                    style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="receiptdate" ngbDatepicker
                    #abcd="ngbDatepicker" (click)="abcd.toggle();">
                  <button class="input-group-addon" (click)="abcd.toggle();" type="button">
                    <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                  </button>
                </div>
              </div> -->
  
              <div class="col-md-3">
                <!-- <label>Date of Complaint was fully satisfied</label> -->
                <!-- <label>From</label> -->
                <br>
                <div class="input-group" (click)="$event.stopPropagation()">
                  From :&nbsp;
                  <input id="dateOfComplaint" class="form-control" [minDate]="futureToDate"
                    style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateOfComplaint" ngbDatepicker
                    #ab="ngbDatepicker" (click)="ab.toggle();bc.close()" [(ngModel)]="dateOfComplaint">
                  <button class="input-group-addon" (click)="ab.toggle();bc.close()" type="button">
                    <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                  </button>
                
                </div>
              </div>
  
  
              <div class="col-md-3">
                <!-- <label>Date of receipt of complaint</label> -->
                <!-- <label>To</label> -->
                <br>
                <div class="input-group" (click)="$event.stopPropagation()">
                
                   To :&nbsp;
                  <input id="dateOfReceiptOfComplaintModel" class="form-control" [minDate]="futureToDateTo"
                  style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateOfReceiptOfComplaintModel" ngbDatepicker
                  #bc="ngbDatepicker" (click)="bc.toggle();ab.close()" [(ngModel)]="dateOfReceiptOfComplaintModel">
                <button class="input-group-addon" (click)="bc.toggle();;ab.close()" type="button">
                  <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                </button>
                </div>
              </div>
  
  
  
              <div class="form-group col-lg-2 col-md-2 col-sm-2">
                <!-- <label>&nbsp;&nbsp;&nbsp;</label> -->
                <br>
                <div class="input-group">
                  <button type="button" [disabled]="response" class="btn btn-sm btn-primary mb-2" (click)="doAdvSearch()">
                    <i class="fa fa-search"></i>&nbsp;Search</button>
                  &nbsp;&nbsp;&nbsp;
                  <button type="button" [disabled]="response" class="btn btn-sm btn-default mb-2"
                    (click)="clearAdvSearch()">
                    <i class="fa fa-refresh"></i>&nbsp;Clear</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Date filter End -->
    <div class="card-block datatable-card-block">
      <div class="row">
        <div class="col-md-12">
          <div class="margin-bottom-50">
            <div class="table-responsive">
              <table datatable [dtOptions]="dtOptionsOfRegisterDirector" [dtTrigger]="dtTriggerRegisterDirector"
                class="table table-hover compact cell-border nowrap stripe" id="directormasterinvestorTable"
                style="cursor: pointer;">
                <thead>
                  <tr>
                    <th>Folio number</th>
                    <th>Date of Complaint <br>was fully satisfied </th>
                    <th style="display: none">Date of Complaint was fully satisfied</th>
                    <th>Date of receipt <br> of complaint</th>
                    <th style="display: none">Date of receipt of complaint</th>
                    <th>Nature of complaint</th>
                    <th>Name of the person <br> lodging the complaint</th>
                    <th>Deposit receipt number</th>
                  
                    <!-- <th>Status</th> -->
                    <th class="actionclass">Action
                      <!-- <span [appHasPermission]="{'Url': '/register/Masterinvestorcomplaints/edit?goveva=true&email=', 'method':'put', 'menu': 'Masterinvestorcomplaints'}">Action</span> -->
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let director of registerDirectorList;let i=index">
                   <td tabindex="1">{{director.folioNumber}}</td>
                   <td tabindex="1">
                      <span style="display: none">{{director.dateOnWhichComplaintWasFullySatisfied | date : "yMMdd"}}</span>
                      {{director.dateOnWhichComplaintWasFullySatisfied | date:"dd-MM-y"}}</td>
                    <td tabindex="1" style="display: none">
                      {{director.dateOnWhichComplaintWasFullySatisfied | date:"dd-MM-y"}}</td>
  
                    <td tabindex="1">
                      <span style="display: none">{{director.dateOfReceiptOfComplaint | date : "yMMdd"}}</span>
                      {{director.dateOfReceiptOfComplaint | date:"dd-MM-y"}}</td>
                    <td tabindex="1" style="display: none">
                      {{director.dateOfReceiptOfComplaint | date:"dd-MM-y"}}</td>
                    <td tabindex="1">{{director.natureOfComplaint}}</td>
                    <td tabindex="1">{{director.nameOfThePersonLodgingTheComplaint}}</td>
                    <td tabindex="1">{{director.depositReceiptNumber}}</td>
                 
                    <td style='white-space: nowrap'>
                      <a>
                        <button type="button" (click)="editinvestor(director._id)" class="btn-sm btn btn-warning" [appHasPermission]="{'Url': '/register/Masterinvestorcomplaints/edit?goveva=true&email=', 'method':'put', 'menu': 'Masterinvestorcomplaints'}" >
                          <span class="fa fa-pencil"></span>
                        </button>
                      </a>
                      <button type="button" class="btn-sm btn btn-danger" (click)="confirmDelete(director._id)" [appHasPermission]="{'Url': '/register/Masterinvestorcomplaints/edit?goveva=true&email=', 'method':'put', 'menu': 'Masterinvestorcomplaints'}" >
                        <span class="icmn-bin"></span>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <div class="modal fade" id="deleteConfirm" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true"
    style="top: 50px;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="myModalLabelForDelete">
            <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-12">
              Are you sure you want to delete Investor Complaint details?
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-danger" (click)="removeinvestordetail()">
            <i class="fa fa-check"></i>&nbsp;Yes
          </button>
          <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
            <i class="fa fa-times"></i>&nbsp;No
          </button>
        </div>
      </div>
    </div>
  </div>
  
  <app-alert></app-alert>